//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { Locales } from 'app/constants/locales/locale';
import { LocalesFlag } from 'app/constants/locales/localesFlag';

export type TermsConditionsSettings = Partial<
  Record<Locales, TermsAndConditionsInfo>
>;

export interface TermsAndConditionsInfo {
  countryFlag: string | undefined;
  fullUrl: string;
  label: string;
  retailerMessages: string[];
  url: string;
}

export const termsConditionsSettings: TermsConditionsSettings = {
  [Locales.EN_US]: {
    countryFlag: LocalesFlag[Locales.EN_US],
    fullUrl: 'https://www.bazaarvoice.com/legal/terms-of-use/visual-content',
    label: 'English',
    retailerMessages: [
      'Your agreement allows us to share on our sites and with retailers.',
      'By agreeing, your content could also be used by retailers.',
      'Learn more about sharing with us and retailers.',
      'Your consent allows us to share on our sites and with retailers.',
    ],
    url: 'https://bv-url.com/vc-tou',
  },

  [Locales.DE_DE]: {
    countryFlag: LocalesFlag[Locales.DE_DE],
    fullUrl:
      'https://www.bazaarvoice.com/de/legal/nutzungsbedingungen-visual-content',
    label: 'German',
    retailerMessages: [
      'Ihre Einwilligung ermöglicht und erlaubt uns, Ihren Inhalt auf unserer Website zu veröffentlichen und an Händler in unserem Netzwerk weiterzugeben.',
      'Wenn Sie einwilligen können Ihre Inhalte auch von den Händlern in unserem Netzwerk verwendet werden.',
      'Erfahren Sie mehr darüber, wie Ihre Inhalte mit Ihrer Einwilligung von uns und von den Händlern in unserem Netzwerk genutzt werden.',
      'Mit Ihrer Zustimmung können wir Ihre Inhalte auf unserer Website veröffentlichen und an Händler in unserem Netzwerk weitergeben.',
    ],
    url: 'https://bv-url.com/de/vc-tou',
  },

  [Locales.FR_FR]: {
    countryFlag: LocalesFlag[Locales.FR_FR],
    fullUrl:
      'https://www.bazaarvoice.com/fr/legal/conditions-dutilisation-des-contenus-visuels',
    label: 'French',
    retailerMessages: [
      'Votre accord nous permet de partager des contenus sur nos sites et sur les sites des distributeurs.',
      'En acceptant, votre contenu pourra également être utilisé par les distributeurs.',
      'En savoir plus sur le partage avec notre organisation et les distributeurs.',
      'Votre consentement nous permet de diffuser des contenus sur nos sites et sur les sites des distributeurs.',
    ],
    url: 'https://bv-url.com/fr/vc-tou',
  },
};
